module.exports = __webpack_public_path__ + "img/shape_circle--blue.b47751b.webp";